import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { useSection } from "./useSection";
import { SaveBar } from "./ui";

export default function StatsEditor({ logout }) {
  const { draft, setDraft, saving, save } = useSection("stats", logout);
  const items = draft || [];

  const setItem = (i, k, v) => setDraft(items.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  const add = () => setDraft([...items, { value: "", label: "" }]);
  const remove = (i) => setDraft(items.filter((_, idx) => idx !== i));

  return (
    <div>
      <SaveBar title="Statistiche" description="I numeri in evidenza nella sezione Chi siamo." saving={saving} onSave={save} />

      <div className="space-y-4 max-w-2xl">
        {items.map((s, i) => (
          <div key={i} className="flex gap-4 items-center bg-white border border-navy/10 p-4">
            <input value={s.value} onChange={(e) => setItem(i, "value", e.target.value)} placeholder="Valore (es. 1500+)" className="w-32 bg-transparent border-b border-navy/15 py-2 text-navy font-serif text-lg focus:outline-none focus:border-gold" />
            <input value={s.label} onChange={(e) => setItem(i, "label", e.target.value)} placeholder="Etichetta" className="flex-1 bg-transparent border-b border-navy/15 py-2 text-sm text-navy placeholder:text-navy/30 focus:outline-none focus:border-gold" />
            <button onClick={() => remove(i)} aria-label="Elimina" className="text-navy/30 hover:text-red-500"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>

      <button onClick={add} className="mt-6 inline-flex items-center gap-2 border border-navy/20 px-5 py-3 text-xs uppercase tracking-[0.18em] text-navy hover:border-gold hover:text-gold transition-colors">
        <Plus size={15} /> Aggiungi statistica
      </button>
    </div>
  );
}
